import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';

import './theme/_variables.scss';
import './theme/typography.css';
import './theme/_main.scss';

import { FrontPageTemplate } from './customizations/volto/components/manage/Blocks/Listing';
import { FrontPageTemplateTermin } from './customizations/volto/components/manage/Blocks/Listing';

function applyConfig(config: ConfigType) {
  installSettings(config);
  /* 
  config.views = {
    ...config.views,
    contentTypesViews: {
      ...config.views.contentTypesViews,
    },
  }; */

  config.settings = {
    ...config.settings,
    logo: '/customisations/components/theme/Logo/Logo.svg',
  };

  config.blocks.blocksConfig.listing.variations = [
    ...config.blocks.blocksConfig.listing.variations,
    {
      id: 'FrontPageListing',
      title: 'FrontPage',
      template: FrontPageTemplate,
    },
    {
      id: 'FrontPageListingTermin',
      title: 'FrontPageTermin',
      template: FrontPageTemplateTermin,
    },
  ];

  return config;
}

export default applyConfig;
